export default __webpack_public_path__ + "assets/images/bfcfae69e2752f04878fbcca7a2d55f7.svg";